'use client';

import { ServerStyleSheet, StyleSheetManager, ThemeProvider } from 'styled-components';
import { ComponentProps, useState } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { GlobalStyles, isDarkMode } from '@/theme';
import { darkTheme } from '@/theme/dark';
import { lightTheme } from '@/theme/light';

function StyleRegistry({ children }: ComponentProps<any>) {
    const [styledComponentsStyleSheet] = useState(() => new ServerStyleSheet());

    useServerInsertedHTML(() => {
        const styles = styledComponentsStyleSheet.getStyleElement();

        styledComponentsStyleSheet.instance.clearTag();

        return styles;
    });

    if (typeof window !== 'undefined') {
        return children;
    }

    return (
        <StyleSheetManager
          sheet={styledComponentsStyleSheet.instance}
        >
            {children}
        </StyleSheetManager>
    );
}

export default function NextThemeProvider({ children }: ComponentProps<any>) {
    const theme = isDarkMode() ? darkTheme : lightTheme;

    return (
        <StyleRegistry>
            <ThemeProvider theme={theme}>
                <GlobalStyles />

                {children}
            </ThemeProvider>
        </StyleRegistry>
    );
}
